import StrutturePresidiListPage from "./pages/StrutturePresidiListPage.vue";
import StrutturePresidiEditPage from "./pages/StrutturePresidiEditPage.vue";
import StrutturePresidiViewPage from "./pages/StrutturePresidiViewPage.vue";

export default {
  StrutturePresidiListPage,
  StrutturePresidiEditPage,
  StrutturePresidiViewPage,
};
